import { create } from "zustand";
import { devtools } from "zustand/middleware";

interface SidebarState {
  isOpen: boolean;
  openSidebar: () => void;
  closeSidebar: () => void;
  toggleSidebar: () => void;
}

/**
 * Controls the mobile navigation drawer (sidebar) open/close state.
 * On desktop (>= md) the sidebar is always visible and this state is ignored.
 */
export const useSidebarStore = create<SidebarState>()(
  devtools(
    (set) => ({
      isOpen: false,
      openSidebar: () => set({ isOpen: true }),
      closeSidebar: () => set({ isOpen: false }),
      toggleSidebar: () => set((state) => ({ isOpen: !state.isOpen })),
    }),
    { name: "SidebarStore" },
  ),
);
